module.exports = __webpack_public_path__ + "static/media/scotia-vida-ico-titular-gris.1c5cdf20.svg";